import { render, staticRenderFns } from "./ActivateSubscriptionPage.vue?vue&type=template&id=65a871e2"
import script from "./ActivateSubscriptionPage.vue?vue&type=script&lang=js"
export * from "./ActivateSubscriptionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports